import { DEFAULT_ACCENT, DEFAULT_PRIMARY } from "../constants/Colors";

import { BRANDING_RECEIVED } from "../constants/ActionTypes";
import logo_url from "../images/logo_default@2x.png";
import { mergeDeepLeft } from "ramda";

const DEFAULT_BRANDING = {
  common: {
    primary_color: DEFAULT_PRIMARY,
    accent_color: DEFAULT_ACCENT,
    logo_url,
    cookie_management_enabled: false
  }
};

export const INITIAL_STATE = { loaded: false, data: DEFAULT_BRANDING };

const branding = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BRANDING_RECEIVED:
      const cookie_management_enabled = action.data?.common.cookie_management_enabled || false;
      const actionData = {...action.data, common: { ...action.data.common, cookie_management_enabled } };
      return {
        data: mergeDeepLeft(actionData, state.data),
        loaded: true
      };
    default:
      return state;
  }
};

export default branding;
